<template>
  <tr
    class="hover:bg-gray-50 transition-colors duration-150 ease-in-out child:px-1.5 child:py-1 first-child:pl-1.5 last-child:pr-1.5 bg-white child:border-b child:border-gray-200"
  >
    <td class="py-1">
      <div class="flex space-x-1.5 items-start">
        <div class="flex shrink-0 space-x-1 pt-0.5">
          <button
            type="button"
            class="btn-icon btn-icon-blue"
            @click="$emit('open-details', contractEvent)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"  class="w-4 h-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
</svg>
          </button>

          <button
            type="button"
            data-test="show-comments"
            class="btn-icon btn-icon-default"
            @click="$emit('open-comment-modal', contractEvent)"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="h-4 w-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
          </button>
        </div>

        <div
          class="min-w-0 flex-1 space-y-0.5"
          :title="contractEvent.cause || ''"
        >
          <div class="flex flex-wrap items-center gap-x-1.5 gap-y-0.5">
            <span class="text-xs font-medium text-gray-900">{{ contractEvent.code }}</span>

            <span
              class="inline-flex items-center px-2 py-0 rounded-full text-xs font-medium border shrink-0"
              :class="ContractEventImpactBadgeClasses[enumKeyFromValue(ContractEventImpact, contractEvent.impact)] ?? 'bg-gray-100 text-gray-800 border-gray-200'"
            >
              {{ $t(`HeadContract.CenSchedule.AddCenModal.impact.${enumKeyFromValue(ContractEventImpact, contractEvent.impact)}`) }}
            </span>
          </div>

          <p class="text-wrap text-xs text-gray-700 leading-snug">
            {{ contractEvent.name }}
          </p>
        </div>
      </div>
    </td>

    <td class="w-36">
      <p
        class="max-h-36 overflow-y-auto text-xs text-gray-700  whitespace-pre-line break-words leading-snug"
        :title="contractEvent.cause || ''"
      >
        {{ contractEvent.cause }}
      </p>
    </td>

    <td class="w-36">
      <p
        class="max-h-36 overflow-y-auto text-xs text-gray-700  whitespace-pre-line break-words leading-snug"
        :title="contractEvent.effect || ''"
      >
        {{ contractEvent.effect }}
      </p>
    </td>

    <td class="w-24 whitespace-nowrap text-xs text-gray-700">
      {{ contractEvent.dateOfOccurrence?.toLocaleString() }}
    </td>

    <td class="w-24 whitespace-nowrap text-xs text-gray-700">
      <span
        class="inline-flex items-center px-2 py-0 rounded-full text-xs font-medium border shrink-0"
        :class="ContractEventStatusBadgeClasses[enumKeyFromValue(ContractEventStatus, contractEvent.status)] ?? 'bg-gray-100 text-gray-800 border-gray-200'"
      >
        {{ $t(`HeadContract.CenSchedule.statusTitles.${enumKeyFromValue(ContractEventStatus, contractEvent.status)}`) }}
      </span>
    </td>

    <td class="w-48 text-xs text-gray-700">
      <ul
        v-if="timeBars.length"
        class="space-y-2"
      >
        <li
          v-for="(timeBar, index) in timeBars"
          :key="index"
          class="leading-snug"
          :style="timeBar.colour ? { color: timeBar.colour } : undefined"
          :title="timeBar.text"
        >
          {{ timeBar.text }}
        </li>
      </ul>
    </td>

    <td class="">
      <ul
        v-if="scheduleComments.length"
        class="max-h-40 overflow-y-auto space-y-2 pr-1 text-xs text-gray-700"
      >
        <li
          v-for="comment in scheduleComments"
          :key="comment.id"
        >
          <p class="font-semibold text-gray-900">
            {{ comment.creator?.name }}

            <span class="text-xs font-normal text-gray-500">
              {{ comment.createdAt.toLocaleString(undefined, {
                hour12: true,
                hour: 'numeric',
                minute: 'numeric',
                day: 'numeric',
                month: 'numeric',
                year: 'numeric'
              }) }}
            </span>
          </p>

          <p class="mt-0.5 whitespace-pre-wrap break-words">
            {{ comment.body }}
          </p>
        </li>
      </ul>
    </td>

    <td
      v-if="project?.unarchived"
    >
      <div class="flex flex-col space-y-1">
        <div class="flex space-x-1 justify-between">
          <div class="group">
            <div class="flex justify-between">
              <span class="text-xs font-medium text-gray-500">
                {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.label.assignee') }}
              </span>

              <button
                type="button"
                @click="clearAssignee"
              >
                <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="text-red-600 w-5 h-5 invisible group-hover:visible">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
              </button>
            </div>

            <AppTypeAhead
              v-model="userNameTypeAhead"
              class="w-full"
              name="cen_next_action_assignee"
              :suggestion-callback="getSuggestions"
              :initial-suggestions="getSuggestions"
              @value-selected="selectUser"
            />
          </div>

          <div class="group">
            <div class="flex justify-between">
              <span class="text-xs font-medium text-gray-500">
                {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.label.dueDate') }}
              </span>

              <button
                type="button"
                @click="clearDate"
              >
                <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="text-red-600 w-5 h-5 invisible group-hover:visible">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
              </button>
            </div>

            <AppInput
              v-model="nextActionForm.form.next_action_due_date"
              name="cen_next_action_due_date"
              type="date"
              class="form-input text-sm"
            />
          </div>
        </div>

        <div class="space-y-1">
          <label class="block text-xs font-medium text-gray-500">
            {{ $t('HeadContract.VariationsSchedule.VariationOrderRow.label.nextAction') }}
          </label>

          <textarea
            v-model="nextActionForm.form.next_action"
            name="cen_next_action"
            class="form-input text-sm resize-none border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            rows="2"
            placeholder="Enter next action..."
            @blur="saveNextAction"
            @keyup.enter="saveNextAction"
          />

          <button
            type="button"
            class="btn--small btn btn--secondary-blue w-full"
            data-test="save-next-action-snapshot"
            :disabled="!canConfirmAssigneeSnapshot"
            @click="emitSaveNextActionSnapshot"
          >
            {{ $t('HeadContract.CenSchedule.button.saveAndNotifyAssignee') }}
          </button>
        </div>
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { useFormData } from '@/composables/useFormData';
import { dateForDateInput, enumKeyFromValue, getCenScheduleTimeBars } from '@/helpers';
import Comment from '@/models/Comment';
import ContractEvent, {
  ContractEventImpact,
  ContractEventImpactBadgeClasses,
  ContractEventStatus,
  ContractEventStatusBadgeClasses,
} from '@/models/ContractEvent';
import { useContractEventsStore } from '@/store/contractEvents';
import { useProjectsStore } from '@/store/projects';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, watch } from 'vue';
import { toast } from 'vue3-toastify';

const props = defineProps<{
  contractEvent: ContractEvent;
}>();

const emit = defineEmits<{
  (
    e: 'save-next-action',
    data: {
      contractEvent: ContractEvent;
      next_action?: string;
      next_action_due_date?: string;
      next_action_assignee_id?: number;
    },
  );
  (
    e: 'save-next-action-snapshot',
    data: {
      contractEvent: ContractEvent;
      next_action?: string;
      next_action_due_date?: string;
      next_action_assignee_id?: number;
    },
  );
  (e: 'open-details', contractEvent: ContractEvent);
  (e: 'open-comment-modal', contractEvent: ContractEvent);
}>();

const projectsStore = useProjectsStore();

const project = computed(() => {
  return projectsStore.project;
});

const timeBars = computed(() => {
  return getCenScheduleTimeBars(props.contractEvent, project.value);
});

const scheduleComments = computed((): Comment[] => {
  const raw = props.contractEvent.comments;

  if(!raw?.length) {
    return [];
  }

  const list = [...raw];

  list.sort((a, b) => {
    const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
    const tb = b.created_at ? new Date(b.created_at).getTime() : 0;

    return tb - ta;
  });

  return list.slice(0, 10);
});

const nextActionForm = useFormData({
  next_action: '',
  next_action_due_date: '',
  next_action_assignee_id: undefined,
});

const userNameTypeAhead = ref('');

watch(
  () => props.contractEvent.id,
  () => {
    nextActionForm.form.next_action = props.contractEvent.next_action ?? '';
    nextActionForm.form.next_action_due_date = dateForDateInput(props.contractEvent.next_action_due_date);
    nextActionForm.form.next_action_assignee_id = props.contractEvent.next_action_assignee_id;
    userNameTypeAhead.value = props.contractEvent.next_action_assignee?.name ?? '';
  },
  { immediate: true },
);

const clearAssignee = () => {
  userNameTypeAhead.value = '';
  nextActionForm.form.next_action_assignee_id = undefined;

  emit('save-next-action', {
    contractEvent: props.contractEvent,
    next_action: nextActionForm.form.next_action,
    next_action_due_date: nextActionForm.form.next_action_due_date,
    next_action_assignee_id: undefined,
  });
};

const clearDate = () => {
  nextActionForm.form.next_action_due_date = '';

  emit('save-next-action', {
    contractEvent: props.contractEvent,
    next_action: nextActionForm.form.next_action,
    next_action_due_date: undefined,
    next_action_assignee_id: nextActionForm.form.next_action_assignee_id,
  });
};

watch(() => nextActionForm.form.next_action_due_date, (newValue) => {
  const date = new Date(newValue);

  if(!isNaN(date.getTime())) {
    const year = newValue.split('-')[0];

    if(parseInt(year) > 2000) {
      emit('save-next-action', {
        contractEvent: props.contractEvent,
        next_action: nextActionForm.form.next_action,
        next_action_due_date: nextActionForm.form.next_action_due_date,
        next_action_assignee_id: nextActionForm.form.next_action_assignee_id,
      });
    }
  }
});

const saveNextAction = () => {
  emit('save-next-action', {
    contractEvent: props.contractEvent,
    next_action: nextActionForm.form.next_action,
    next_action_due_date: nextActionForm.form.next_action_due_date,
    next_action_assignee_id: nextActionForm.form.next_action_assignee_id,
  });
};

const canConfirmAssigneeSnapshot = computed(() => {
  return !!nextActionForm.form.next_action_assignee_id && nextActionForm.form.next_action.trim();
});

const emitSaveNextActionSnapshot = () => {
  emit('save-next-action-snapshot', {
    contractEvent: props.contractEvent,
    next_action: nextActionForm.form.next_action,
    next_action_due_date: nextActionForm.form.next_action_due_date || undefined,
    next_action_assignee_id: nextActionForm.form.next_action_assignee_id,
  });

  nextActionForm.resetData();
  userNameTypeAhead.value = '';
};

const suggestedUsers = ref<{ id: number; name: string }[]>([]);

const getSuggestions = async () => {
  suggestedUsers.value = await projectsStore
    .searchUsers(project.value?.id, { name: userNameTypeAhead.value });

  return suggestedUsers.value.map((value) => value.name);
};

const selectUser = (index: number) => {
  nextTick(() => {
    if(suggestedUsers.value[index]) {
      nextActionForm.form.next_action_assignee_id = suggestedUsers.value[index].id;
      saveNextAction();
    }
  });
};
</script>
